import useSWR from 'swr';
import { useScope } from './useScope';
import { Scope } from '@/typings/fe';
import { forumPostService } from '@/api/forumPost';

const fetcher = async (_url: string, scope: Scope) => {
  const res = await forumPostService.getBanners({
    Scope: scope,
  });
  if (res.error) {
    throw new Error();
  }
  return res.data;
};

export const useBanner = () => {
  const scope = useScope();

  const { data, isValidating } = useSWR(['banner', scope], fetcher);

  return {
    banners: data?.Banners || [],
    loading: isValidating,
  };
};
